import React from "react"

import { ShopButtonWrapper, AltShopButtonWrapper } from "../styled"

import { globalHistory } from "@reach/router"

import { marketingCTAClicked } from "../../segment"
import { Link } from "gatsby"

const ShopButton = (props) => {
  const currentLocation =
    globalHistory && globalHistory.location ? globalHistory.location.href : "/"

  const handleClick = () => {
    marketingCTAClicked(
      `${process.env.GATSBY_MAGENTO_URL}hair/brand/product/category/`,
      currentLocation,
      "Shop",
      "link"
    )
  }

  return (
    <>
      {props.mobileNav ? (
        <AltShopButtonWrapper>
          <a
            href={`${process.env.GATSBY_MAGENTO_URL}hair/brand/product/category/`}
            onClick={handleClick}
            target="_blank"
            rel="noopener noreferrer"
            tabIndex={1}
          >
            <span>Shop </span>
            <img src={props.image} alt={`click to shop`} />
          </a>
        </AltShopButtonWrapper>
      ) : (
        <ShopButtonWrapper>
          <a
            href={`${process.env.GATSBY_MAGENTO_URL}hair/brand/product/category/`}
            onClick={handleClick}
            target="_blank"
            rel="noopener noreferrer"
            tabIndex={1}
          >
            <img src={props.image} alt={`click to shop`} />
          </a>
        </ShopButtonWrapper>
      )}
    </>
  )
}

export default ShopButton
